import { Factory } from 'fishery';
import {
  ProductType,
  ProductSegment,
} from 'QuoteApp/services/endpoints/GetDetails/types';
import { GetAvailableProductsResponseType } from './types';

type OptionsTransientParams = {
  productType?: ProductType;
  productSegment?: ProductSegment;
  carrierName?: string;
  mga?: string;
};

export const getAvailableProductsFactory = Factory.define<
  GetAvailableProductsResponseType,
  OptionsTransientParams
>(({ transientParams }) => [
  {
    productType: transientParams.productType || 'personalAuto',
    productSegment: transientParams.productSegment || 'standardAuto',
    companyInfo: {
      carrierName:
        transientParams.carrierName || 'Clearcover Insurance Company',
      mga: transientParams.mga || null,
    },
  },
]);
